<template>
    <BaseModal
        video
        :is-open="modalStore.modals.video"
        @close="closeModal">
        <div
            class="container flex flex-col justify-center"
            @click.self="closeModal">
            <button
                class="relative z-20 size-14 self-end rounded-4 border border-ash-200 outline-none"
                @click="closeModal">
                <svg
                    viewBox="0 0 70 70"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    width="70"
                    height="70"
                    class="size-14">
                    <path
                        d="M48.5 48.5L21 21"
                        stroke="white"></path>
                    <path
                        d="M48.5 21L21 48.5"
                        stroke="white"></path>
                </svg>
            </button>
            <div
                style="
                    cursor:
                        url(/assets/images/ui/icons/jpg-png/close-cursor.png),
                        pointer;
                "
                class="absolute inset-0 z-0"
                @click="closeModal"></div>
            <iframe
                id="player"
                title="Rutube video player"
                ref="iframe"
                allow="clipboard-write; autoplay"
                :src="`https://rutube.ru/play/embed/${modalStore.videoLink}?skinColor=743FDA&autoplay=true`"
                class="relative z-10 mt-4 aspect-video w-full bg-black transition-all duration-300" />
        </div>
    </BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '~/components/base/base-modal/BaseModal.vue'

const modalStore = useModalStore()

function closeModal() {
    modalStore.close('video')
}
</script>
